
import { defineComponent, ref, watchEffect } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface formData {
  duration: string;
  startDate: string;
  endDate: string;
}

export default defineComponent({
  name: "step-2",
  components: {
    Field,
    ErrorMessage,
    DropDownSection,
  },
  methods: {
    validateStartDate() {
      this.showErrorMessage = false;
      if (
        this.step2.startDate != null &&
        this.step2.startDate != "" &&
        new Date(this.step2.startDate) < new Date()
      ) {
        this.step2.startDate = "";
        this.showErrorMessage = true;
      }
      if (new Date(this.step2.endDate) < new Date(this.step2.startDate)) {
        this.step2.endDate = "";
      }
    },
    validateEndDate() {
      this.showErrorMessageForEndDate = false;
      if (
        this.step2.endDate != null &&
        this.step2.endDate != "" &&
        (new Date(this.step2.endDate) < new Date(this.step2.startDate) ||
          new Date(this.step2.startDate) < new Date())
      ) {
        this.step2.endDate = "";
        this.showErrorMessageForEndDate = true;
      }
    },
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
         {title: "Information", descriptions: [{description:
          " Some Information" }
        ]},
         
    ];
    const formRef = ref<null | HTMLFormElement>(null);
    const showErrorMessage = false;
    const showErrorMessageForEndDate = false;
    const step2 = ref<formData>({
      duration: "",
      startDate: "",
      endDate: "",
    });

    const rules = ref({
      startDate: [
        {
          required: true,
          message:
            "Please select a start date that is on or after today. Dates prior to today are not allowed for the start date.",
          trigger: "change",
        },
      ],
      endDate: [
        {
          required: true,
          message:
            "Please choose an end date that comes after the selected start date.",
          trigger: "change",
        },
      ],
    });

    watchEffect(() => {
      const data = store.getters.currentResearch;
      if (data === null || data.data === undefined) return;
      step2.value.duration = data.data.duration || "";
      step2.value.startDate = data.data.startDate;
      step2.value.endDate = data.data.endDate;
    });

    return {
      step2,
      formRef,
      rules,
      showErrorMessage,
      showErrorMessageForEndDate,
      listDropDownSections,
    };
  },
});
